import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import FieldRadio from '../FieldRadio/FieldRadio';

class FieldSetNewAssessmentTabular extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event) {
        const {
            field, form, options, booleanField,
        } = this.props;
        const { value } = event.target;

        options.forEach((option, i) => {
            const optionId = `${option.id}`;
            if (value === optionId) {
                const values = Object.assign({}, form.values);
                values[field.name] = value;
                if (booleanField) {
                    values[field.name] = value;
                } else {
                    values[field.name] = {
                        [`option-${option.id}`]: `${i + 1}`,
                    };
                }
                form.setValues(values);
            }
        });
    }

    render() {
        const { optionId, field } = this.props;
        const fieldName = field.name;


        return (
            <Field
                value={`${optionId}`}
                appearance="default"
                component={FieldRadio}
                onChange={this.handleChange}
                name={`${fieldName}_option`}
                id={`${optionId}_option`}
                ariaLabelledby={`radio-${optionId}-label`}
            />
        );
    }
}

FieldSetNewAssessmentTabular.propTypes = {
    field: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({}),
        ]),
    }).isRequired,
    form: PropTypes.shape({
        errors: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.shape({}),
            PropTypes.string,
        ])),
        touched: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({}),
        ])),
    }).isRequired,
    optionId: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    booleanField: PropTypes.bool,
};
FieldSetNewAssessmentTabular.defaultProps = {
    options: [],
    booleanField: false,
};

export default FieldSetNewAssessmentTabular;
